// @flow

const INITIAL_STATE = {
  categories: [], error: null, loading: false, activeCategoty: null
}

const outboundAffiliates = (state: any = INITIAL_STATE, action: any) => {
  switch(action.type) {
    case 'FETCH_OUTBOUND_AFFILIATES':
      return { ...state, loading: true };
    case 'FETCH_OUTBOUND_AFFILIATES_SUCCESS':
      return { ...state, categories: action.payload, error: null, loading: false, activeCategory: action.payload && action.payload[0] };
    case 'SET_ACTIVE_OUTBOUND_AFFILIATE_CATEGORY':
      return { ...state, activeCategory: action.payload };
    case 'FETCH_OUTBOUND_AFFILIATES_FAILURE':
      return { ...state, categories: null, error: action.payload, loading: false };

    default:
      return state;
  }
}

export default outboundAffiliates;



// WEBPACK FOOTER //
// ./src/reducers/outboundAffiliates.js